<div class="form-container service-form ms-large-t" #formContainer>
  <!-- Initial form state -->
  <form
    *ngIf="reactiveForm && (formStatus === FormStatus.INITIAL || formStatus === FormStatus.ERROR)"
    [formGroup]="reactiveForm"
    [finFormErrorFocus]="reactiveForm"
    (ngSubmit)="onSubmit()"
  >
    <!-- Error notification -->
    <fcom-notification
      *ngIf="formStatus === FormStatus.ERROR"
      class="mr-medium-y"
      [layout]="NotificationLayout.BLOCK"
      [theme]="NotificationTheme.ALERT"
    >
      {{ 'SERVICE_FORMS.serviceForms.error.title' | finLocalization }}
    </fcom-notification>
    <span class="block font-body-1 mr-medium-b nordic-blue-900-text">
      {{ 'SERVICE_FORMS.serviceForms.mandatoryFields' | finLocalization }}
    </span>
    <h3>{{ 'SERVICE_FORMS.serviceForms.cancellationCoverClaim.bookingDetailsTitle' | finLocalization }}</h3>
    <div class="flex flex--row flex--wrap form-subgroup">
      <fcom-text-input
        [parentForm]="reactiveForm"
        [controlName]="'bookingReference'"
        [placeHolder]="'SERVICE_FORMS.serviceForms.fields.reservationNumber.placeholder'"
        [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.reservationNumber'"
      ></fcom-text-input>
      <fcom-text-input
        [parentForm]="reactiveForm"
        [controlName]="'ticketNumber'"
        [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.ticketNumber'"
        [placeHolder]="'SERVICE_FORMS.serviceForms.fields.ticketNumber.placeHolder'"
      ></fcom-text-input>
    </div>

    <h3>{{ 'SERVICE_FORMS.serviceForms.cancellationCoverClaim.yourDetailsTitle' | finLocalization }}</h3>
    <div class="flex flex--row flex--wrap form-subgroup">
      <fcom-text-input
        [parentForm]="reactiveForm"
        [controlName]="'firstName'"
        [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.firstName'"
      ></fcom-text-input>
      <fcom-text-input
        [parentForm]="reactiveForm"
        [controlName]="'familyName'"
        [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.lastName'"
      ></fcom-text-input>
      <fcom-text-input
        [parentForm]="reactiveForm"
        [controlName]="'email'"
        [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.email'"
      ></fcom-text-input>
      <fcom-text-input
        [parentForm]="reactiveForm"
        [controlName]="'phoneNumber'"
        [placeHolder]="'SERVICE_FORMS.serviceForms.fields.phoneNumber.placeholder'"
        [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.phoneNumber'"
      ></fcom-text-input>
    </div>

    <h3>{{ 'SERVICE_FORMS.serviceForms.cancellationCoverClaim.claimTitle' | finLocalization }}</h3>
    <div class="flex flex--row flex--wrap form-subgroup ms-large-b">
      <fcom-radio-item-group
        [attr.data-testid]="'refundFor'"
        [options]="[{ value: 'departureAndReturnFlights' }, { value: 'returnFlight' }]"
        [parentForm]="reactiveForm"
        [controlName]="'refundFor'"
        [translationPrefix]="'SERVICE_FORMS.serviceForms.cancellationCoverClaim.fields.refundFor'"
      >
      </fcom-radio-item-group>
    </div>

    <div class="form-subgroup form-group-wide">
      <fcom-file-uploader
        [allowedFileTypes]="allowedFileTypes"
        [controlName]="'file'"
        [customAttachLabel]="
          'SERVICE_FORMS.serviceForms.cancellationCoverClaim.fields.medicalAttachment.label' | finLocalization
        "
        [customRequiredLabel]="
          'SERVICE_FORMS.serviceForms.cancellationCoverClaim.fields.medicalAttachment.required' | finLocalization
        "
        [i18n]="'SERVICE_FORMS.serviceForms.fields.fileUploader' | finLocalization"
        [maxAttachments]="maxAttachments"
        [maxSizeInBytes]="maxSizeInBytes"
        [parentForm]="reactiveForm"
        #fileUploader
      ></fcom-file-uploader>
      <fin-form-input-checkbox
        class="block ml-0"
        [parentForm]="reactiveForm"
        [controlName]="'attachmentConsent'"
        [translationPrefix]="'SERVICE_FORMS.serviceForms.cancellationCoverClaim.fields.medicalAttachmentConsent'"
      >
      </fin-form-input-checkbox>
    </div>

    <cms-unstyled-fragment
      *ngIf="'fragments.privacyPolicyLink.url' | finLocalization"
      class="block font-body-1 ml-0 mr-large-b privacy-policy nordic-blue-900-text"
      [contentUrl$]="'fragments.privacyPolicyLink.url' | finLocalization | finToObservable"
    >
    </cms-unstyled-fragment>

    <div class="flex mr-small-t submit-container">
      <fcom-button
        [text]="'SERVICE_FORMS.serviceForms.submit' | finLocalization"
        [type]="ButtonType.SUBMIT"
      ></fcom-button>
    </div>
  </form>
  <!-- While sending -->
  <div *ngIf="formStatus === FormStatus.LOADING" class="relative loader">
    <fin-loader [type]="LoaderType.INLINE"></fin-loader>
  </div>
  <!-- Success view -->
  <div *ngIf="formStatus === FormStatus.COMPLETE">
    <h2>{{ 'SERVICE_FORMS.serviceForms.success.title' | finLocalization }}</h2>
    <p [innerHTML]="'SERVICE_FORMS.serviceForms.cancellationCoverClaim.success' | finLocalization"></p>
  </div>
</div>
